import { render, staticRenderFns } from "./PageSubHeader.vue?vue&type=template&id=2c9a23bb&scoped=true"
import script from "./PageSubHeader.vue?vue&type=script&lang=js"
export * from "./PageSubHeader.vue?vue&type=script&lang=js"
import style0 from "./PageSubHeader.vue?vue&type=style&index=0&id=2c9a23bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9a23bb",
  null
  
)

export default component.exports